import type { MarketVariants } from '@/lib/i18n'

export type Slide3StopContactCopy = {
  eyebrow: string
  title: string
  // Spelling auto-conversion (via toMarketSpelling, applied in useSlideCopy):
  //   apologize -> apologise   (GB, AU; CA keeps "apologize")
  body: string
}

export const copy: MarketVariants<Slide3StopContactCopy> = {
  US: {
    eyebrow: 'Step one',
    title: 'Stop the conversation immediately.',
    body:
      "End the call. Close the message. Shut the page. If they contact you again, do not respond. Scammers may apologize, threaten, or offer to “help,” but it is all designed to pull you back in.",
  },
  ar: {
    eyebrow: 'الخطوة الأولى',
    title: 'أوقف التواصل فوراً.',
    body:
      'أنهِ المكالمة. أغلق الرسالة. أغلق الصفحة. وإذا تواصلوا معك مرة أخرى فلا تردّ. قد يعتذر المحتالون، أو يهدّدون، أو يعرضون "المساعدة"، لكن كل ذلك مصمَّم لإعادتك إلى الفخ.',
  },
}
